import React from 'react';

// Styles & Assets
import styles from './BlueCell.module.css';

// Interfaces
interface Props {
    show: boolean
    children: React.ReactNode
}

const BlueCell: React.FC<Props> = ({ show, children }) => {

    return (
        <div className={show ? styles.blueCell : ''}>
            {children}
        </div>
    );
};

export default BlueCell;